import axios from "axios"

class CompcardAPI {
  create = async params => {
    return axios.post("api/fashion-model-compcards", params)
  }
}

export const compcard = new CompcardAPI()
